import React from "react";
import classNames from "classnames";
import { PageProps } from "./PropsType";

export default function Page(props: PageProps) {
  const { className, isActive = true, children } = props;
  const styleClass = classNames(
    "Page",
    className,
    isActive ? "Page-active" : "Page-on-right"
  );
  return <div className={styleClass}>{children}</div>;
}
